import "./GlobalLayout.css";

import useLocationSearch from "hooks/useLocationSearch";
import React from "react";
import Helmet from "react-helmet";

import {
  currentLinkAtom,
  megaMenuOpenAtom,
} from "./newHeader/atoms/headerAtoms";
import Header from "./newHeader/Header";
import { CTA_BUTTON_COPY } from "components/data/landing-page-data";
import FooterV2 from "./footer/FooterV2";
import FooterCTA from "./footer/FooterCTA";
import useCookieBanner from "hooks/useCookieBanner";
import { useSetAtom } from "jotai";

const META_DATA = [
  {
    name: "description",
    content:
      "Secure, cloud-managed video surveillance for enterprise, business, or commercial property. No DVR/NVRs required. Easy to manage. Infinitely scalable.",
  },
  {
    name: "keywords",
    content:
      "video security, cloud video security, rhombus, rhombus systems, cloud managed security cameras, video surveillance, cloud cctv, enterprise video security, enterprise security cameras, business security cameras",
  },
];

export default function GlobalLayout({
  children,
  color = "var(--white)",
  dark = false,
  landingPage = false,
  formOnly = false,
  customLinks = null,
  ctaLink = "#form",
  useIncreasedPadding = false,
  logoLink = "/",
  includeButton = false,
  buttonType = "primary",
  useFullWidth = false,
  useFullWidthLogo = false,
  disableStickyHeader = false,
  hideFooter = false,
  useCTAFooter = false,
  buttonText = CTA_BUTTON_COPY,
  useExperimentalFooter = false,
  expirementalFooterMenus,
}) {
  useCookieBanner();
  useLocationSearch();
  const setMegaMenuOpen = useSetAtom(megaMenuOpenAtom);
  const setCurrentLink = useSetAtom(currentLinkAtom);

  return (
    <div className={"globalLayoutClass"}>
      <Helmet
        title={"Rhombus - Next-Generation Enterprise Security Camera System"}
        meta={META_DATA}
      >
        {/* all static head components should be handled in gatsby-ssr */}
        <script
          defer
          src="https://cmp.osano.com/6oqOkUUtG7mC6ScB/d1fbf09f-ecd3-4390-8c69-e28269c3377f/osano.js"
        ></script>
        <script>
          {`!function(w,o,d){w[o]=w[o]||function(){w[o][d].push(arguments)},w[o][d]=w[o][d]||[]}(window,"Osano","data");window.Osano("onInitialized",e=>{countryCode=window.Osano.cm.countryCode,"us"===countryCode&&window.Osano.cm.hideDialog()});`}
        </script>
      </Helmet>
      <Header
        color={color}
        dark={dark}
        landingPage={landingPage}
        customLinks={customLinks}
        ctaLink={ctaLink}
        useIncreasedPadding={useIncreasedPadding}
        logoLink={logoLink}
        includeButton={includeButton}
        buttonType={buttonType}
        useFullWidth={useFullWidth}
        useFullWidthLogo={useFullWidthLogo}
        disableStickyHeader={disableStickyHeader}
        buttonText={buttonText}
      />
      <main
        onClick={() => {
          setMegaMenuOpen(false);
          setCurrentLink(null);
        }}
      >
        {children}
      </main>
      {!formOnly && !hideFooter && (
        <FooterV2
          useExperimentalFooter={useExperimentalFooter}
          expirementalFooterMenus={expirementalFooterMenus}
        />
      )}
      {useCTAFooter && hideFooter && <FooterCTA />}
    </div>
  );
}
